// src/components/admin/design/AiRecommenderPreview.tsx
"use client";

import UniversalProductCardPreview from "./UniversalProductCardPreview";

export interface PreviewProps {
  variantId: string;
  primaryColor?: string;
  theme?: "dark" | "light";
  subdomain?: string;
}

export default function AiRecommenderPreview({
  variantId = "door_hanger",
  primaryColor = "#059669",
  theme,
  subdomain,
}: PreviewProps) {
  return (
    <UniversalProductCardPreview
      sectionTitle="AI Recommender"
      variantId={variantId}
      primaryColor={primaryColor}
      theme={theme}
      subdomain={subdomain}
    />
  );
}